import { render } from "./testmäng.vue?vue&type=template&id=72efed5e"
import script from "./testmäng.vue?vue&type=script&lang=js"
export * from "./testmäng.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__